import { routeOptions } from "@/constants/constants";
import { useAuthContext } from "@/hooks/useAuthContext";
import { useFirestore } from "@/hooks/useFirestore";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function BottomBar() {
  const { user } = useAuthContext();
  const { updateDocument: updateUser } = useFirestore("users");
  const navigate = useNavigate();

  const routes = routeOptions;

  useEffect(() => {
    async function updateLastSeen() {
      await updateUser(user.uid, {
        lastSeen: new Date().getTime(),
      });
    }

    updateLastSeen();
  }, []);

  return (
    <div className="fixed w-full bg-muted border border-border h-16 flex justify-between items-center">
      {routes.map(function (option, index) {
        if (option.hidden) return null;
        if (option.admin && !user.admin) return null;
        return (
          <div
            key={option.route}
            role="button"
            className={`relative flex flex-col items-center justify-center w-full h-full text-xs font-medium text-center transition-all duration-300 ${
              index === 0 ? "text-primary" : "text-secondary"
            }`}
            onClick={() => {
              if (option.external) {
                window.open(option.route, "_blank");
              } else {
                navigate(option.route);
              }
            }}
          >
            {option.icon}
            {option.badge && (
              <p className="absolute top-1.5 right-5 text-[18px] font-light rounded-sm">
                🔥
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}
